namespace Areas.Dialogs.Transmittal {
    "use strict";

    export class CreateTransmittalDialog extends Areas.BaseDialog {

        constructor(closeHandler: (dialogResult: DialogResult, data: any) => void, parameters: any) {
            super("CreateTransmittal", closeHandler, parameters, () => {
                const form = $("#CreateTransmittalForm").dxForm("instance");
                const formData: any = form.option("formData");

                formData.ProjectName = parameters.projectName;
                formData.ProjectNumber = parameters.projectNumber;
                formData.AccountId = parameters.accountId;
                formData.Description = "Test";
                formData.ReferenceTable = parameters.referenceTable; 

                form.option("formData", formData);
            });
        }

        protected ok = (e: any) => {
            const form = $("#CreateTransmittalForm").dxForm("instance");
            const result: any = form.validate();

            if (result.isValid) {

                const newData: any = form.option("formData");
                newData.RecordIds = this.parameters.data.map(i => i.changeManagementId);

                sendRequest("/Dialog/CreateTransmittal/Post", JSON.stringify(newData), "POST", () => {
                    this.close(DialogResult.Ok, null);
                });
            }
        }
    }

    export function selectFromContact() {
        const form = $("#CreateTransmittalForm").dxForm("instance");
        const formData: any = form.option("formData");

        const parameters = { accountId: formData.AccountId };

        const accountTeamLookupDialog = 
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("from"), parameters, "accountTeamDialog");

    }

    export function selectToContact() {
        const form = $("#CreateTransmittalForm").dxForm("instance");
        const formData: any = form.option("formData");

        const parameters = { accountId: formData.AccountId };

        const accountTeamLookupDialog = 
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("to"), parameters, "accountTeamDialog");

    }    

    function accountTeamDialogClosing(fromOrTo: string) {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;
    
            const form = $("#CreateTransmittalForm").dxForm("instance");

            const formData = form.option("formData");

            if (fromOrTo === "from") {
                formData.FromCompany = data.companyName;
                formData.FromContactName = data.displayName;
                formData.FromContactId = data.contactId;   
            } else {
                formData.ToCompany = data.companyName;
                formData.ToContactName = data.displayName;
                formData.ToContactId = data.contactId;   
            }

            form.option("formData", formData);
        } 
    
    }    

}
